import { render, staticRenderFns } from "./BookClassFormSection.vue?vue&type=template&id=ef11d7fc&scoped=true&"
import script from "./BookClassFormSection.vue?vue&type=script&lang=js&"
export * from "./BookClassFormSection.vue?vue&type=script&lang=js&"
import style0 from "./BookClassFormSection.vue?vue&type=style&index=0&id=ef11d7fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef11d7fc",
  null
  
)

export default component.exports